module.exports = __webpack_public_path__ + "static/media/image-5.aeecf5c6.png";